import styled from 'styled-components'

export const ContainerCertificacao = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1000px;
  margin: 0 auto;
  flex: 1;
`
